import { Injectable, inject } from "@angular/core";
import { ApiService } from "app/core/api/api.service";
import { Observable } from "rxjs";
import { SupportRequest, SupportTicketResponse } from "./support-request.types";

@Injectable({ providedIn: "root" })
export class SupportRequestService {
  private readonly _apiService = inject(ApiService);

  createTicket(request: SupportRequest): Observable<SupportTicketResponse> {
    const formData = new FormData();
    formData.append("email", request.email.trim());
    formData.append("comments", request.comments.trim());

    if (request.document) {
      formData.append("document", request.document, request.document.name);
    }

    return this._apiService.post<SupportTicketResponse>("support", formData);
  }
}
